import React from "react";
import { Redirect, Route } from "react-router-dom";

import { AuthService } from "../../../../../services/AuthService";

class ProtectedRouteNode extends React.Component {
  render() {
    const { component: Component, ...rest } = this.props;
    const isAuthenticated = AuthService.currentUserValue() ? true : false;
    const isActualNode = AuthService.getCurrentNodeCode() !== 0;
    const hasPermissions = true; // Analizar si tiene el permiso

    const user = AuthService.currentUserValue();

    return (
      <Route
        {...rest}
        render={(props) => {
          if (!isActualNode) {
            return (
              <Redirect
                to={{
                  pathname: this.props.redirectUrl
                    ? this.props.redirectUrl
                    : "/admin/active-node",
                }}
              />
            );
          }
          return isAuthenticated && hasPermissions ? (
            <Component {...props} user={user} />
          ) : (
            <Redirect
              to={{
                pathname: this.props.redirectUrl
                  ? this.props.redirectUrl
                  : "/login",
              }}
            />
          );
        }}
      />
    );
  }
}

ProtectedRouteNode.propTypes = {};

export default ProtectedRouteNode;
